import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useEditableCellLink } from "components/DataGrid/editableCellLink";

interface WarehouseLocationLinkProps {
  code?: string | null;
  locationId?: number | string | null;
}

export const WarehouseLocationLink = ({ code, locationId }: WarehouseLocationLinkProps) => {
  const to = locationId ? `/locations/${locationId}/edit` : "";
  const { onClick } = useEditableCellLink(to);

  if (!code) return null;
  if (!locationId) return <>{code}</>;

  return (
    <Link component={RouterLink} to={to} onClick={onClick}>
      {code}
    </Link>
  );
};
